import { useContent } from '../App.jsx';
import PageHero from '../components/PageHero.jsx';
import { ArrowIcon, ExternalIcon, LocationIcon } from '../components/Icons.jsx';

export default function LocationPage() {
  const { content } = useContent();
  const venues = content.venues.filter((venue) => venue.visible);
  return (
    <>
      <PageHero eyebrow="Valley Forge" title="Stay close to the classes—and the ceilidh." body="The workshop is hosted in King of Prussia, Pennsylvania, with two neighboring Marriott properties available for attendees." />
      <section className="section page-width venue-grid">
        {venues.map((venue) => (
          <article className={venue.primary ? 'primary-venue' : ''} key={venue.id}>
            <div className="venue-number"><LocationIcon /></div>
            <p className="eyebrow">{venue.primary ? 'Workshop hotel' : 'Additional rooms'}</p>
            <h2>{venue.name}</h2>
            <p>{venue.address}</p>
            {venue.phone && <p>{venue.phone}</p>}
            <a className="button button-dark" href={venue.bookingUrl} target="_blank" rel="noreferrer">Book your room <ExternalIcon /></a>
          </article>
        ))}
      </section>
      <section className="travel-strip"><div className="page-width"><div><p className="eyebrow eyebrow-light">Getting here</p><h2>Minutes from Philadelphia. Easy from across the Northeast.</h2></div><p>The hotels sit near the Pennsylvania Turnpike and are approximately 30 miles from Philadelphia International Airport.</p></div></section>
    </>
  );
}
